import { UseBaseQueryOptions, useQuery } from '@tanstack/react-query'
import { TagsQueryKeys } from '../../constants'
import { PlayerTagResponse, GetPlayerTagsRequest } from '../../types'
import { getPlayerTags } from '../services'

export default function useQueryGetPlayerTags(
	params?: GetPlayerTagsRequest,
	props?: UseBaseQueryOptions<PlayerTagResponse[]>,
) {
	return useQuery({
		queryKey: [TagsQueryKeys.GetTags, params],
		queryFn: () => getPlayerTags(params),
		...props,
	})
}
